(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__hover-prev, .product-card__hover-next');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var container = btn.closest('.product-card__hover-images');
    var imgs = Array.from(container.querySelectorAll('.product-card__hover-img'));
    var activeIdx = imgs.findIndex(function (img) { return img.classList.contains('is-active'); });
    imgs[activeIdx].classList.remove('is-active');
    if (btn.classList.contains('product-card__hover-next')) {
      activeIdx = (activeIdx + 1) % imgs.length;
    } else {
      activeIdx = (activeIdx - 1 + imgs.length) % imgs.length;
    }
    imgs[activeIdx].classList.add('is-active');
  });
})();
